import Bowser from 'bowser';

import BROWSERSLIST from '../../browserslist';

/*
 * If a browser is on this blacklist, then we don't allow the user to use the
 * app and instead show them a message asking  to upgrade their browser.
 *
 * This list should be kept in sync with Webpack/esbuild config.
 *
 * The purpose of this blacklist is to reduce the support requests and error reporting
 * noise originating from unsupported browsers.
 */
const UNSUPPORTED_BROWSERS = {
  desktop: {
    chrome: `<${BROWSERSLIST.CHROME}`,
    safari: `<${BROWSERSLIST.SAFARI}`,
    firefox: `<${BROWSERSLIST.FIREFOX}`,
  },
  ios: {
    safari: `<${BROWSERSLIST.IOS}`,
  },
};

const isBrowserSupported = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  return !browser.satisfies(UNSUPPORTED_BROWSERS);
};

export default isBrowserSupported;
